import SEOHead from '@/components/base/SEOHead';

const homepageSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'BaoyuTV',
    url: 'https://baoyutv.com',
    description: 'BaoyuTV是备受用户青睐的高清视频平台，提供海量影视、综艺、动漫等内容资源。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'BaoyuTV',
    url: 'https://baoyutv.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://baoyutv.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'BaoyuTV官方入口·高清视频平台',
    description: 'baoyutv是备受用户青睐的高清视频平台，提供海量影视、综艺、动漫等内容资源。',
    url: 'https://baoyutv.com',
    isPartOf: {
      '@type': 'WebSite',
      name: 'BaoyuTV',
      url: 'https://baoyutv.com',
    },
  },
];

export default function SEOTags() {
  return (
    <SEOHead
      title="BaoyuTV官方入口·高清视频平台 - 海量影视综艺动漫资源"
      description="baoyutv是备受用户青睐的高清视频平台，提供海量影视、综艺、动漫等内容资源。本页为您详解baoyutv的核心功能、使用方法、最新入口及常见问题，助您快速畅享优质视频体验。"
      keywords="baoyutv,baoyutv官网入口,baoyutv最新地址,baoyutv高清视频,baoyutv使用教程,baoyutv资源下载,baoyutv会员权益"
      canonicalUrl="https://baoyutv.com"
      ogTitle="BaoyuTV官方入口·高清视频平台 - 海量影视综艺动漫资源"
      ogDescription="baoyutv是备受用户青睐的高清视频平台，提供海量影视、综艺、动漫等内容资源。核心功能、使用方法、最新入口及常见问题一览。"
      schema={homepageSchema}
    />
  );
}